
import React, { Component } from 'react';
import { Fragment } from 'react';
import {
  isPresetEventDuration,
} from '../../../../utils/eventConfigHelpers';

const time = [
    {
        value: '5',
        text: '5'
    },
    {
        value: '10',
        text: '10'
    },
    {
        value: '15',
        text: '15'
    },
    {
        value: '30',
        text: '30'
    },
    {
        value: '45',
        text: '45'
    },
    {
        value: '60',
        text: '60'
    },
    {
        value: '0',
        text: '000',
        type: 'custom'
    },

]

class TimeSelectorField extends Component {

    state = {
        textboxValue: "",
    }

    componentDidMount() {
        const { defaultValue } = this.props;
        if (
            !isPresetEventDuration(defaultValue) &&
            defaultValue &&
            String(defaultValue) !== "0"
        ) {
            this.setState({
                textboxValue: String(defaultValue),
            });
        }
    }

    componentDidUpdate(prevProps) {
        const { defaultValue } = this.props;
        if (
            prevProps.defaultValue !== defaultValue &&
            !isPresetEventDuration(defaultValue) &&
            defaultValue &&
            String(defaultValue) !== "0"
        ) {
            this.setState({
                textboxValue: String(defaultValue),
            });
        }
    }

    handleChange = ( { target } ) => {
        const { onChange, handleFormChange } = this.props;
        
        // disable invitee set duration
        handleFormChange({
            target: {
              name: "invitee_set_duration_status",
              value: "D",
            },
          });

        const { value } = target || {};
        if(target.getAttribute('data-type') === "text") {
            this.setState({
                textboxValue: value
            })
        }
        onChange(value);
    }

    render() {
        const { textboxValue } = this.state || {};
        const { defaultValue, inviteeSetDurationStatus } = this.props || {};
        const normalizedDefault = String(defaultValue ?? "");
        const useCustomDuration =
            inviteeSetDurationStatus === "D" &&
            normalizedDefault &&
            !isPresetEventDuration(normalizedDefault);
        const customDisplayValue =
            textboxValue || (useCustomDuration ? normalizedDefault : "");

        return (
            <div className="time-selector-wrapper">
                {
                    (time || []).map((e, i) => {
                        const { text, value, type } = e || {};
                        return (
                            <Fragment key={ i }>
                                {
                                    type === "custom"
                                    ?
                                    <div className="event-form-check" key={ i }>
                                        <input type="number" id={ text } value = { customDisplayValue } placeholder={ text } onChange = { this.handleChange } data-type="text" name = "time"></input>
                                    </div>  
                                    :
                                    <div className="event-form-check" key = { i }>
                                        <input type="radio" id={ text } value = { value } onChange = { this.handleChange } checked = {
                                            (normalizedDefault === value && inviteeSetDurationStatus === 'D') ? true : false
                                        } name = "time"></input>
                                        <label htmlFor={ text }>
                                            <span> { text } </span>
                                            
                                        </label>
                                    </div> 
                                }
                            </Fragment>
                        )
                    })
                }
            </div>
        )
    }
}

export default TimeSelectorField;
